module.exports = __webpack_public_path__ + "media/sapa_archive/kantrocornertitlebg620x167v5-19cc548a.gif";